import { useSelector } from "react-redux";

import { getUser } from "src/state/user";

export default function useLoggedInUser() {
    return useSelector(getUser)
}